<template>
  <div class="drug-siderbar">
    <van-sidebar v-model="activeId" @change="handleChange">
      <van-sidebar-item :title="item.name" v-for="(item, key) in category" :key="key" />
    </van-sidebar>
  </div>
</template>

<script>
export default {
  props: ['category'],
  data() {
    return {
      activeId: 0
    };
  },
  methods: {
    handleChange(index) {
      // eslint-disable-next-line
      Telescope.trackEvent({ trackId: 'yd_category_productlist_tab', custom: { category: this.category[index] } });
      this.$emit('changeCategory', index);
    }
  }
};
</script>

<style lang="scss" scoped>
.drug-siderbar {
  ::v-deep .van-sidebar-item {
    font-size: 12px;
    color: #8c8c8c;
    background-color: #f7f8fa;
    padding: 15px;
  }
  ::v-deep .van-sidebar-item--select {
    background-color: #fff;
    color: #1e8dff;
    font-weight: 500;
  }
  .van-sidebar-item--select::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 3px;
    height: 100%;
    transform: none;
    content: '';
  }
}
</style>
